// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"822":"95f7dd5c488c14ac","8885":"e0b5d3044545efff"}[chunkId] + ".css";
};